import { render } from "./ForgotPINView.vue?vue&type=template&id=4217068a"
import script from "./ForgotPINView.vue?vue&type=script&lang=js"
export * from "./ForgotPINView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Mobile\\mobile\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__